import * as React from "react";

const MenuDownArrow: React.FC = () => {
    return (
      <svg width="8px" height="3px" viewBox="0 0 8 3" version="1.1" xmlns="http://www.w3.org/2000/svg" >
        <title>Icons/menuDownArrow</title>
        <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Font_Home_Default" transform="translate(-400.000000, -83.000000)" stroke="#33333A">
                <g id="Group" transform="translate(0.000000, 40.000000)">
                    <polyline id="Icons/menuDownArrow" points="401 43 404 46 407 43"></polyline>
                </g>
            </g>
        </g>
    </svg>
    );
};

export default React.memo(MenuDownArrow);